import { render, staticRenderFns } from "./personSet.vue?vue&type=template&id=235ffee0&scoped=true&"
import script from "./personSet.vue?vue&type=script&lang=js&"
export * from "./personSet.vue?vue&type=script&lang=js&"
import style0 from "./personSet.vue?vue&type=style&index=0&id=235ffee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ffee0",
  null
  
)

export default component.exports